import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDeleteComponent } from 'src/app/shared-component/components/confirm-delete/confirm-delete.component';
import { MaterialModule } from './materials.module'; 
@NgModule({
  declarations: [
    ConfirmDeleteComponent
  ],
  imports: [
    CommonModule,
    ToastrModule.forRoot(),
    MaterialModule,
    HttpClientModule,
    TranslateModule.forChild(),
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[
    MaterialModule,
    TranslateModule,
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDeleteComponent,
  ]
})
export class ModuleModule { }
